var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle, _circle2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPosIntlBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 286,
  height: 579,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M108.999 427.486h103m-102.651-77h101.274M126.999 376.486h85M211.999 323.486v225m-26-220v19.145m0 80.675v96.18m-23-197v19.145m0 80.675v116.18m-25-216v19.145m0 80.675v147.18m99-271v268M125.999 401.486h86M93.989 363.805c0-7.395 6.71-13.055 14.989-13.055M93.989 414.718c0 7.395 6.71 13.055 14.989 13.055M93.989 363.152c0 7.395-6.711 13.055-14.99 13.055M93.989 414.719c0-7.395-6.711-13.055-14.99-13.055"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeWidth: 6,
  d: "M86 475.486c13.788 0 24.967 11.179 24.967 24.968M86 525.422c13.788 0 24.967 11.178 24.967 24.967M285.739 475.486c-13.789 0-24.967 11.179-24.967 24.968M285.739 525.422c-13.789 0-24.967 11.178-24.967 24.967M135.934 525.422c-13.789 0-24.967-11.178-24.967-24.968M135.934 575.355c-13.789 0-24.967-11.178-24.967-24.967M235.804 525.422c13.789 0 24.968-11.178 24.968-24.968M235.804 575.355c13.789 0 24.968-11.178 24.968-24.967"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M-48.65 253.356h-3a3 3 0 0 0 3 3zm3 0c0-41.684 32.234-71.903 72.138-71.903v-6c-43.092 0-78.138 32.781-78.138 77.903zm-3 3H71.22v-6H-48.65zm75.138-74.903H93.22v-6H26.488zM-23.526 350.227a3 3 0 1 1 0 6zM-48.65 328.26h-3a3 3 0 0 1 3-3zm3 0c0 13.125 9.8 21.967 22.124 21.967v6c-15.427 0-28.124-11.321-28.124-27.967zm-3-3h99.87v6h-99.87z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M14.601 276.289H71.22M26.25 303.291h24.967"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinecap: "round",
  strokeWidth: 6,
  d: "M-10.367 289.606c0 6.435 5.961 11.652 13.316 11.652"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinecap: "round",
  strokeWidth: 6,
  d: "M1.285 301.258c7.354 0 13.316-5.52 13.316-12.33V276.29M12.936 328.26c7.153 0 12.952-6.025 12.952-13.457v-11.511"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeWidth: 6,
  d: "M26.25 182.291v-28.804"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M-101.152 475.988v-86.892c0-6.905 5.695-12.502 12.72-12.502h168.22M-51.454 525.686H85.79"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M47.94 512.433c0 7.319-5.933 13.253-13.252 13.253M23.093 403.099v10.308c0 7.115-5.69 12.884-12.708 12.884H-.099M-101.152 426.292c0-14.085 10.82-24.849 24.167-24.849H23.09"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M-1.758 475.989v-49.06c0-14.075 10.224-25.486 24.42-25.486H80"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M-1.758 475.989c0 13.724-11.125 24.849-24.848 24.849M34.688 376.594c7.32 0 13.253 5.597 13.253 12.502v123.336"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M47.94 324.746v50.192"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 23.279,
  cy: 450.983,
  r: 3,
  fill: "#F0F0F0",
  stroke: "#F0F0F0",
  strokeWidth: 4.008
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.279,
  cy: 475.379,
  r: 3,
  fill: "#F0F0F0",
  stroke: "#F0F0F0",
  strokeWidth: 4.008
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M70.982 29.031h-220.981M51.009 153.275H-150"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M-.907 103.578v24.849M23.94 53.88H-.907M23.94 78.73H-.907"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M48.789 103.578H-.908M93.176 128.426H-.908M-150 4.184H72.502"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M111.387 229.031c-8.235 0-14.91-6.675-14.91-14.909M180.963 229.031c8.234 0 14.909-6.675 14.909-14.909"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M195.872 214.123v-59.636M96.477 215.779v-61.293M111.383 229.031h71.233"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M103.485 278.41h12.743M140.438 278.41h12.743"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M168.021 204.184a3 3 0 0 0 6 0zm6 0v-49.697h-6v49.697z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M177.392 278.41h12.743M96.475 179.334c-14.075 0-24.848 11.266-24.848 25.163v99.08M71.627 303.577c0 13.724 11.44 24.849 25.55 24.849h98.692M195.871 179.334c14.884 0 24.256 10.872 24.828 24.481m.021 1.005q0-.505-.021-1.005m0 0v99.762M195.871 328.426c13.724 0 24.849-11.125 24.849-24.849"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M71.627 278.73c0 13.723 11.38 24.848 25.42 24.848h98.822"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M189.999 303.486h51.127M46.779 303.578h22.3"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M195.868 303.578c13.724 0 24.849-11.125 24.849-24.848M121.325 179.334h24.849v24.849h-24.849z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeWidth: 6,
  d: "M82.652 117.608c0 5.477-3.884 11.652-11.652 11.652M82.652 119.271V99.298M170.871 154.227v-26.632M195.837 154.227v-49.935M220.805 94.305v-18.31M145.904 104.291c14.299 0 24.967 10.668 24.967 24.967M145.902 104.291c-14.3 0-24.968-10.668-24.968-24.967M107.619 77.66c-14.3 0-24.967 10.668-24.967 24.968M230.793 103.51h4.11c6.004 0 10.871-4.867 10.871-10.87V77.658"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeWidth: 6,
  d: "M231.675 103.51c-6.003 0-10.87-4.867-10.87-10.87M206.71 77.607c-6.004 0-10.871 4.867-10.871 10.87v17.692M193.342 129.26h27.464M71 129.26h99.87"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M270.74 74.29a3 3 0 1 1 0 6zM71 74.29h199.74v6H71z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeWidth: 6,
  d: "M258.255 41.872c0 6.648 5.836 12.484 12.484 12.484M208.321 41.872c0 6.648 5.836 12.484 12.484 12.484M158.387 41.872c0 6.648 5.836 12.484 12.484 12.484M108.45 41.872c0 6.648 5.836 12.484 12.484 12.484M258.257 41.872c0-6.648-5.835-12.483-12.483-12.483M208.32 41.872c0-6.648-5.835-12.483-12.483-12.483M158.386 41.872c0-6.648-5.835-12.483-12.483-12.483M108.452 41.872c0-6.648-5.835-12.483-12.483-12.483M233.29 41.872c0-6.648 5.835-12.483 12.484-12.483"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeWidth: 6,
  d: "M183.353 41.872c0-6.648 5.835-12.483 12.484-12.483M133.419 41.872c0-6.648 5.835-12.483 12.484-12.483M83.485 41.872c0-6.648 5.835-12.483 12.484-12.483M233.289 41.872c0 6.648-5.836 12.484-12.484 12.484M183.355 41.872c0 6.648-5.836 12.484-12.484 12.484M133.418 41.872c0 6.648-5.835 12.484-12.484 12.484M83.484 41.872c0 6.648-5.835 12.484-12.484 12.484"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M220.804 129.259c27.578 0 49.935-23.276 49.935-49.935"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeWidth: 6,
  d: "M160.901 550.389c0-13.789 11.178-24.967 24.967-24.967"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeWidth: 6,
  d: "M185.867 525.422c13.79 0 24.968 11.178 24.968 24.967M135.933 575.355c13.789 0 24.968-11.178 24.968-24.967M235.802 575.355c-13.789 0-24.967-11.178-24.967-24.967"
})));
export { SvgPosIntlBg as ReactComponent };
export default __webpack_public_path__ + "static/pos-intl-bg.a0fe2109.svg";